<template>
    <b-modal
        id="modal-excluir-profissional"
        title="Confirmar Exclusão"
        v-model="visivel"
        @ok="handleOk"
        ok-title="Sim"
        cancel-title="Não"
        ok-variant="danger"
        cancel-variant="secondary"
        centered
    >
        <p class="my-2">
            Deseja realmente excluir o profissional <strong>{{ profissional ? profissional.nomeCompleto : '' }}</strong>?
        </p>
    </b-modal>
</template>

<script>
export default {
    name: 'DeclaracaoVinculoExclusaoModal',
    data() {
        return {
            visivel: false,
            profissional: null
        }
    },
    methods: {
        show(profissional) {
            this.profissional = profissional;
            this.visivel = true;
        },
        hide() {
            this.visivel = false;
            this.profissional = null;
        },
        handleOk() {
            if (this.profissional) {
                this.$emit('confirmar', this.profissional);
            }
        }
    }
}
</script>
